import React from 'react'
import ReactDOM from 'react-dom'
import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import Chart from 'chart.js/auto'

const DATASETS_COLOR = '#ec144c';

export default class ProgressViewer extends React.Component {
    constructor (props) {
        super(props)

        this.graph = React.createRef()

        this.state = {
            activeType: 'weight'
        }
    }

    unCamelCase (str) {
        const result = str.replace(/([A-Z])/g, ' $1')
        return result.charAt(0).toUpperCase() + result.slice(1)
    }

    prepareDataSet () {
        let data = [{
            label: this.state.activeType,
            backgroundColor: DATASETS_COLOR,
            borderColor: DATASETS_COLOR,
            borderWidth: 3,
            pointRadius: 2,
            pointHoverRadius: 4,
            data: [],
            fill: false,
        }]

        for (const progressItemType in this.props.items) {
            if (!Object.prototype.hasOwnProperty.call(this.props.items, progressItemType)) continue
            if (progressItemType === this.state.activeType) {
                data[0].data = this.props.items[progressItemType] ? this.props.items[progressItemType].dataset : []
            }
        }

        return data
    }

    updateChart () {
        if (this.chart) {
            this.chart.data.labels = []
            this.chart.data.datasets = []
            if (this.props.items[this.state.activeType]) {
                this.chart.data.labels = this.props.items[this.state.activeType].labels.map(label => label)
                this.chart.data.datasets = this.prepareDataSet()
            }
            this.chart.update()
        }
    }

    componentDidMount () {
        const data = {
            labels: this.props.items[this.state.activeType] ? this.props.items[this.state.activeType].labels.map(label => label) : [],
            datasets: this.prepareDataSet()
        }

        const options = {
            elements: {
                line: {
                    tension: 0.4
                }
            },
            spanGaps: true,
            plugins: {
                legend: {
                    display: false,
                    labels: {
                        usePointStyle: true
                    }
                },
            }
        }

        const ctx = this.graph.current.getContext('2d')
        this.chart = new Chart(ctx, {
            type: 'line',
            data: data,
            options: options
        })
    }

    render () {
        return <>
            <div className={"row d-flex justify-content-center"}>
                <select name={'selection'} className={"custom-select custom-select-sm w-50 text-center"} onChange={(event) => {
                    this.setState({ activeType : event.target.value }, this.updateChart)
                }} value={this.state.activeType}>
                    <option value={'weight'}>Greutate</option>
                    <option value={'chest'}>Bust/Piept</option>
                    <option value={'arms'}>Brate</option>
                    <option value={'waist'}>Talie</option>
                    <option value={'hips'}>Solduri</option>
                    <option value={'thigh'}>Coapse</option>
                </select>
            </div>
            <canvas className="sh-barGraph" ref={this.graph}/>
        </>
    }
}

document.addEventListener('DOMContentLoaded', function () {
    if (document.getElementById('progressViewer')) {
        const propsContainer = document.getElementById("progressViewer");
        const props = Object.assign({}, propsContainer.dataset);
        props.items = JSON.parse(props.items)
        delete propsContainer.dataset.items
        ReactDOM.render(<ProgressViewer items={props.items}/>, propsContainer)
    }

    let calendarEl = document.getElementById('calendar');

    if (calendarEl) {
        let calendar = new Calendar(calendarEl, {
            timeZone: 'UTC+2',
            locale: 'ro',
            plugins: [dayGridPlugin],
            initialView: 'dayGridMonth',
            selectable: false,
            events: JSON.parse(calendarEl.getAttribute('data-gym')),
            contentHeight: 'auto',
            height: 'auto',
            headerToolbar: {
                start: 'title',
                center: '',
                end: 'prev,next'
            },
        });

        calendar.render();
    }
});

